<template>
  <div
    class="app-content content"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  >
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <slot name="breadcrumb">
        <app-breadcrumb />
      </slot>
      <div
        class="content-body"
        :class="{ 'content-body--enter': contentEntering }"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  components: {
    AppBreadcrumb,
  },
  data() {
    return {
      contentEntering: false,
      enterTimer: null,
    }
  },
  watch: {
    '$route.name'(to, from) {
      if (!from || to === from) return
      this.playCleanEnter()
    },
  },
  beforeDestroy() {
    if (this.enterTimer) clearTimeout(this.enterTimer)
  },
  methods: {
    playCleanEnter() {
      // Soft enter only (no leave / no overlay) — avoids stuck transitions
      this.contentEntering = false
      if (this.enterTimer) clearTimeout(this.enterTimer)
      this.$nextTick(() => {
        this.contentEntering = true
        this.enterTimer = setTimeout(() => {
          this.contentEntering = false
          this.enterTimer = null
        }, 180)
      })
    },
  },
  setup() {
    const { contentWidth } = useAppConfig()

    return {
      contentWidth,
    }
  },
}
</script>

<style scoped>
.content-body--enter {
  animation: content-clean-enter 0.18s ease-out;
}

@keyframes content-clean-enter {
  from {
    opacity: 0.55;
  }
  to {
    opacity: 1;
  }
}
</style>
